import { createSelector } from 'reselect';

const selectDomains = (state: any) => state.domains;


export const selectDomainsCurrentItem = createSelector([selectDomains], (domains) => domains.current);

export const selectDomainsListItems = createSelector([selectDomains], (domains) => domains.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDomainsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDomainsQueryItems = createSelector([selectDomains], (domains) => domains.query);

export const selectDomainsCreatedItem = createSelector([selectDomains], (domains) => domains.create);

export const selectDomainsUpdatedItem = createSelector([selectDomains], (domains) => domains.update);

export const selectDomainsReadItem = createSelector([selectDomains], (domains) => domains.read);

export const selectDomainsDeletedItem = createSelector([selectDomains], (domains) => domains.delete);

export const selectDomainsSearchedItems = createSelector([selectDomains], (domains) => domains.search);

export const selectDomainsItemsCount = createSelector([selectDomains], (domains) => domains.count);

export const selectDomainsItemsFilter = createSelector([selectDomains], (domains) => domains.filter);